const useStringArray = () => {
  const mapStringToArray = (stringValue, hideNoValue) => {
    // only allows 0-9 inputs
    const stringListVal = stringValue.toString().split(',');

    const stringListArray = stringListVal.map((p) => {
      if (!hideNoValue || (hideNoValue && p.indexOf('no value') === -1)) {
        return p.split('|');
      }
      else {
        return [''];
      }
    });
    return stringListArray;
  };

  return {
    mapStringToArray: mapStringToArray,
  };

};

export default useStringArray;